import React from 'react';
import { withFormik, Field, Form, getIn } from 'formik';
import * as Yup from 'yup';
import { Button, Row, Col, Modal } from 'react-bootstrap';
import { FormikSelect, FormikTimePicker } from '../../../components';
import { delayMethod } from '../../../services/utils';
import timeTypes from '../../../components/Attendance/formOptions';

const AttendanceUpdateForm = props => {
  const {
    errors,
    touched,
    setFieldValue,
    handleModalClose,
    onHide,
    isSubmitting,
    setFieldTouched,
    values,
    attendance
  } = props;
  const { attendance: vAttendance } = values;
  const { timeType: vTimeType } = vAttendance;

  return (
    <Form>
      <Row>
        <Col md={12} className="d-grid">
          <p>
            Si modificas la hora de marcación de una asistencia y el turno es nocturno, asegúrate de que la fecha sea la
            correcta.
          </p>
          <p>
            <strong>Ejemplo:</strong>
            <br />- <strong>Turno nocturno:</strong> 20-05-2025 <strong>(22:00)</strong> → 21-05-2025{' '}
            <strong>(05:00)</strong>
            <br />- Si registras la hora de salida a las <strong>04:30</strong>, la fecha debe ser{' '}
            <strong>21-05-2025</strong>, no el <strong>20-05-2025</strong>.
          </p>
          <p>Verifica siempre la fecha antes de guardar los cambios.</p>
          <span>
            <b>Trabajador:</b> {attendance.name}
          </span>
          <span>
            <b>Rut:</b> {attendance.nationalIdentification}
          </span>
          <span>
            <b>Fecha:</b> {attendance.date}
          </span>
          <br />
        </Col>
        <Col md={6}>
          <Field name="attendance[parsedTime]">
            {({ field }) => (
              <FormikTimePicker
                {...field}
                abbr
                label="Hora"
                showTimeSelect
                selected={vAttendance?.time ? new Date(vAttendance?.time) : null}
                timeIntervals={1}
                timeCaption="Hora"
                timeFormat="p"
                dateFormat="Pp"
                onChange={date => {
                  setFieldValue(`attendance[time]`, date);
                  setFieldValue(field.name, date.toLocaleString('en-GB'));
                }}
                setFieldTouched={() => setFieldTouched(field.name)}
                error={getIn(errors, field.name)}
                touched={getIn(touched, field.name)}
              />
            )}
          </Field>
        </Col>
        <Col md={6}>
          <Field name="attendance[timeType]">
            {({ field }) => (
              <FormikSelect
                {...field}
                abbr
                label="Tipo de Hora"
                isDisabled={vAttendance.id === null}
                placeholder="Seleccionar Tipo de Hora"
                options={timeTypes}
                defaultValue={vTimeType}
                onChange={data => setFieldValue(field.name, data ? data.value : '')}
                error={getIn(errors, field.name)}
                touched={getIn(touched, field.name)}
              />
            )}
          </Field>
        </Col>
      </Row>
      <Modal.Footer>
        <Button className="text-center" variant="outline-info" onClick={() => delayMethod(handleModalClose)}>
          Cancelar
        </Button>
        <Button type="submit" variant="primary" onClick={onHide} disabled={isSubmitting}>
          Guardar
        </Button>
      </Modal.Footer>
    </Form>
  );
};

const setInitialValues = props => {
  const { attendance, timeType } = props;
  const { shift, date } = attendance;
  const [day, month, year] = date.split('/');
  const formatDate = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
  return {
    attendance: {
      id: attendance.id,
      time: attendance?.time ? new Date(attendance?.time) : new Date(`${formatDate}T03:00:00.000+00:00`),
      employeeId: attendance.employeeId,
      timeType: timeType ?? null,
      parsedTime: attendance.parsedTime ?? `${date}, 00:00:00`,
      shiftId: shift?.id,
      date
    }
  };
};

const validationSchema = Yup.object().shape({
  attendance: Yup.object().shape({
    time: Yup.string().required('Debes escoger la hora'),
    timeType: Yup.string().required('Debes escoger el tipo de hora')
  })
});

const handleSubmit = (values, { props, setSubmitting }) => {
  const { formRequest } = props;
  formRequest(values, setSubmitting);
};

export default withFormik({
  mapPropsToValues: setInitialValues,
  validationSchema,
  handleSubmit,
  enableReinitialize: false,
  validateOnMount: false
})(AttendanceUpdateForm);
